import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Home, Syringe, UserCheck, FlaskConical, Salad, Droplets, ArrowRight } from "lucide-react";

const SERVICE_ICONS = [Syringe, UserCheck, FlaskConical, Salad, Droplets];

export default function HomeHealthPage() {
  const { t } = useLanguage();
  const homeHealth = t("home_health");

  if (typeof homeHealth !== 'object') return null;

  return (
    <div className="min-h-screen pt-20">
      <section className="py-20 bg-[#F4F1EA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center space-y-4">
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#4A6753]">{homeHealth.overline}</span>
          <h1 data-testid="home-health-page-title" className="font-heading text-4xl sm:text-5xl tracking-tight text-[#1E2922] font-semibold">
            {homeHealth.title}
          </h1>
        </div>
      </section>

      <section className="py-24 bg-[#FDFBF7]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 space-y-12">
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 rounded-2xl bg-[#4A6753]/10 flex items-center justify-center shrink-0">
              <Home size={32} className="text-[#4A6753]" strokeWidth={1.5} />
            </div>
            <p data-testid="home-health-intro" className="text-base leading-relaxed text-[#566D60]">
              {homeHealth.intro}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {Array.isArray(homeHealth.services) && homeHealth.services.map((service, i) => {
              const Icon = SERVICE_ICONS[i] || Syringe;
              return (
                <div key={i} data-testid={`home-health-service-${i}`} className="bg-[#F4F1EA] rounded-2xl p-6 border border-transparent hover:border-[#E2E0D9] transition-all">
                  <div className="w-12 h-12 rounded-xl bg-[#4A6753]/10 flex items-center justify-center mb-4">
                    <Icon size={22} className="text-[#4A6753]" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-lg font-medium text-[#1E2922] mb-2 font-heading">{service.title}</h3>
                  <p className="text-sm leading-relaxed text-[#566D60]">{service.description}</p>
                </div>
              );
            })}
          </div>

          <div className="bg-[#4A6753]/5 rounded-2xl p-8 border border-[#4A6753]/10 space-y-4">
            <p className="text-base leading-relaxed text-[#566D60]">{homeHealth.benefits}</p>
            <p className="text-base font-medium text-[#4A6753]">{homeHealth.cta}</p>
          </div>

          <div className="text-center">
            <Link to="/contact" data-testid="home-health-contact-link" className="inline-flex items-center gap-2 bg-[#4A6753] text-white rounded-full px-8 py-3.5 font-medium hover:bg-[#3A5242] transition-colors shadow-sm">
              {t("hero.cta")} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
